module.exports = __webpack_public_path__ + "static/media/buscar.2d074828.png";